<template>
  <q-banner
    class="full-width q-pa-none"
    :class="$isColorDark(bannerBackgroundColorHex) ? 'text-white' : 'text-dark'"
    :style="`background-color: ${bannerBackgroundColorHex}`"
  >
    <div
      class="row justify-between no-wrap relative-position"
      :style="{
        'max-width': isFullWidth ? '100%' : $getMaxWidthForScreenSize(),
        'margin-left': 'auto',
        'margin-right': 'auto'
      }"
    >
      <div
        class="column justify-center q-pr-md q-py-sm"
        :class="{ 'q-pl-sm': isFullWidth || isEditing }"
      >
        <q-icon
          v-if="showIcon && !$_.isNil(iconName)"
          :name="iconName"
          size="md"
        />
      </div>
      <div
        class="column full-width q-px-md q-py-sm"
      >
        <div
          class="text-h6"
          :class="`text-${headerTextAlign}`"
        >
          <component
            :is="$_.isNil(headerLinkType) ? 'span' : 'a'"
            @click="handleHeaderLinkClick"
          >
            {{ headerContent }}
          </component>
        </div>
        <div
          v-if="bodyContent"
          :class="`text-${bodyTextAlign}`"
        >
          <component
            :is="$_.isNil(bodyLinkType) ? 'span' : 'a'"
            @click="handleBodyLinkClick"
          >
            {{ bodyContent }}
          </component>
        </div>
      </div>
      <div
        class="column items-end q-pl-md q-py-sm"
        :class="{ 'q-pr-sm': isFullWidth || isEditing }"
      >
        <q-btn
          v-if="isDismissable"
          flat
          round
          dense
          icon="close"
          @click="dismiss"
        />
      </div>
    </div>
  </q-banner>
</template>

<script>
export default {
  name: 'Banner',
  configuration: ['currentSite'],
  props: {
    headerContent: {
      type: String,
      required: false,
      default: 'I am a GlobalWidget of type Banner...'
    },
    headerTextAlign: {
      type: String,
      required: false,
      default: 'center'
    },
    headerLinkType: {
      type: String,
      required: false,
      default: null
    },
    headerLinkUrl: {
      type: String,
      required: false,
      default: null
    },
    bodyContent: {
      type: String,
      required: false,
      default: null
    },
    bodyTextAlign: {
      type: String,
      required: false,
      default: 'center'
    },
    bodyLinkType: {
      type: String,
      required: false,
      default: null
    },
    bodyLinkUrl: {
      type: String,
      required: false,
      default: null
    },
    backgroundColor: {
      type: String,
      required: false,
      default: null
    },
    backgroundColorHex: {
      type: String,
      required: false,
      default: null
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    iconName: {
      type: String,
      required: false,
      default: null
    },
    isDismissable: {
      type: Boolean,
      required: false,
      default: true
    },
    isFullWidth: {
      type: Boolean,
      required: false,
      default: false
    },
    isEditing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['dismiss'],
  computed: {
    bannerBackgroundColorHex () {
      if (this.backgroundColor === 'custom') {
        return this.backgroundColorHex || '#ffffff'
      } else {
        const backgroundColorHex = this.$getSiteColorHex(this.currentSite, this.backgroundColor)
        return backgroundColorHex || '#ffffff'
      }
    }
  },
  methods: {
    dismiss () {
      this.$emit('dismiss')
    },
    handleHeaderLinkClick () {
      if (_.isNil(this.headerLinkUrl)) return

      if (this.isEditing) {
        window.alert(`Banner link clicked in edit mode: ${this.headerLinkUrl}`)
        return
      }

      this.$trackEvent(this.$customerEvents.CLICKED_BANNER_LINK, { banner_link_url: this.headerLinkUrl })

      if (_.startsWith(this.headerLinkUrl, 'http')) {
        window.open(this.headerLinkUrl, '_blank')
      } else {
        this.$router.push(this.headerLinkUrl)
      }
    },
    handleBodyLinkClick () {
      if (_.isNil(this.bodyLinkUrl)) return

      if (this.isEditing) {
        window.alert(`Banner link clicked in edit mode: ${this.bodyLinkUrl}`)
        return
      }

      this.$trackEvent(this.$customerEvents.CLICKED_BANNER_LINK, { banner_link_url: this.bodyLinkUrl })

      if (_.startsWith(this.bodyLinkUrl, 'http')) {
        window.open(this.bodyLinkUrl, '_blank')
      } else {
        this.$router.push(this.bodyLinkUrl)
      }
    }
  }
}
</script>

<style scoped>
a {
  cursor: pointer;
  text-decoration: underline;
}

a:hover {
  opacity: 0.7;
}
</style>
